module.exports = __webpack_public_path__ + "static/media/icone-agendamento.dee3dbf5.png";